import React from "react";
import Table from "react-bootstrap/Table";
import { Pause, Pencil, Play, Trash2 } from "lucide-react";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { saveChangeStatusPromo } from "../Actions";
const { confirm } = Modal;

const ListingPromos = ({
  t,
  mode,
  promos,
  productId,
  setPromos,
  service,
  provider,
  loadData,
  editPromotion,
}) => {
  /* if (data.length === 0) {
    return;
  }*/
  const labels = [
    t("actions"),
    t("name"),
    t("discount"),
    t("booking date"),
    t("start date of the promotion"),
    "",
  ];

  const actions = [
    {
      id: 1,
      title: t("pausing"),
      icon: <Pause size={20} strokeWidth={1.5} />,
      icon2: <Play size={20} strokeWidth={1.5} />,
      className: "text-dark",
      action: "stop",
    },
    {
      id: 2,
      title: t("edit"),
      icon: <Pencil size={20} strokeWidth={1.5} />,
      className: "text-dark",
      action: "edit",
    },
    {
      id: 3,
      title: t("delete"),
      icon: <Trash2 size={20} strokeWidth={1.5} />,
      className: "text-danger",
      action: "delete",
    },
  ];
  const remise = { percentage: "%", amount: provider.currency };
  const handleChangeStatus = async (item, index, act) => {
    const titleConfirm = {
      disabled: t("do_you_really_want_to_deactivate_this_promotion"),
      enabled: t("do_you_really_want_to_activate_this_promotion"),
      deleted: t("do_you_really_want_to_delete_this_promotion"),
    };

    var status = item.status === "enabled" ? "disabled" : "enabled";
    if (act === "delete") {
      status = "deleted";
    }
    item.status = status;
    var data = promos;
    data[index] = item;

    confirm({
      icon: <ExclamationCircleOutlined />,
      content: <p>{titleConfirm[item.status]}</p>,
      okText: t("confirm"),
      cancelText: t("cancel"),
      onOk: async () => {
        const res = await saveChangeStatusPromo(productId, item.id, status);
        if (res === true) {
          setTimeout(() => {
            setPromos(data);
            loadData();
          }, "1000");
        }
      },
      onCancel() {},
    });
  };
  const handlePoromo = async (item, index, act) => {
    switch (act) {
      case "edit":
        editPromotion(item);
        break;

      default:
        handleChangeStatus(item, index, act);
        break;
    }
  };

  const setIcon = (item, status) => {
    if (status === "disabled" && item.action === "stop") {
      return item.icon2;
    }
    return item.icon;
  };
  console.log('promos',promos)
  return (
    <>
      <div className="border h-100">
        <Table responsive>
          <thead>
            <tr>
              {labels.map((label) => (
                <th className="px-5 py-3 fw-light bg-light">{label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {promos?.map((promo, index) => (
              <tr className="align-middle text-center">
                <td className="px-5 py-3">
                  <div className="d-flex align-items-center">
                    {actions.map((action) => (
                      <span
                        key={action.id}
                        role="button"
                        title={action.title}
                        className={`mx-1 ${action.className}`}
                        onClick={() =>
                          handlePoromo(promo, index, action.action)
                        }
                      >
                        {setIcon(action, promo.status)}
                      </span>
                    ))}
                  </div>
                </td>
                <td className="px-5 py-3">{promo.name}</td>
                <td className="px-5 py-3">
                  {promo.cost} {remise[promo.type]}
                </td>
                <td className="px-5 py-3">
                  {promo.from_at} - {promo.to_at}
                </td>
                <td className="px-5 py-3">
                  {promo.from_date_at} - {promo.to_date_at}
                </td>
                <td className={`px-5 py-3 ${promo.status}`}>
                  {t(promo.status)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
};
export default ListingPromos;
